import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/ImportEstimationSwitchProject/ImportEstimationSwitchProject.tsx";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useStore } from 'effector-react';
import * as smApi from '@gmini/sm-api-sdk';
import { useEffect, useMemo, useState } from 'react';
import { AllFolders } from '@gmini/ui-kit';
import { importEstimationService } from "../../model";
import { SwitchProject } from "../../../../components";
import { BadgeLabel, ProjectSourceBubble } from "./ImportEstimationSwitchProject.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImportEstimationSwitchProject = function ImportEstimationSwitchProject(_ref) {
  var currentUserClassifier$ = _ref.currentUserClassifier$;
  var fetchProjectListPending = useStore(smApi.Project.fetchList.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 29,
      column: 34
    },
    name: "ImportEstimationSwitchProject",
    sid: "ImportEstimationSwitchProject /src/classifier-editor/ImportEstimation/components/ImportEstimationSwitchProject/ImportEstimationSwitchProject.tsx [29, 34]"
  });
  var currentUserClassifier = useStore(currentUserClassifier$, {
    loc: {
      file: _effectorFileName,
      line: 32,
      column: 32
    },
    name: "ImportEstimationSwitchProject",
    sid: "ImportEstimationSwitchProject /src/classifier-editor/ImportEstimation/components/ImportEstimationSwitchProject/ImportEstimationSwitchProject.tsx [32, 32]"
  });
  var selectedProject = useStore(importEstimationService.selectedProject$, {
    loc: {
      file: _effectorFileName,
      line: 33,
      column: 26
    },
    name: "ImportEstimationSwitchProject",
    sid: "ImportEstimationSwitchProject /src/classifier-editor/ImportEstimation/components/ImportEstimationSwitchProject/ImportEstimationSwitchProject.tsx [33, 26]"
  });
  var projectList = useStore(importEstimationService.projectList$, {
    loc: {
      file: _effectorFileName,
      line: 34,
      column: 22
    },
    name: "ImportEstimationSwitchProject",
    sid: "ImportEstimationSwitchProject /src/classifier-editor/ImportEstimation/components/ImportEstimationSwitchProject/ImportEstimationSwitchProject.tsx [34, 22]"
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openedSwitchProjectPopup = _useState2[0],
      setOpenedSwitchProjectPopup = _useState2[1];

  var currentProject = useMemo(function () {
    return projectList.find(function (_ref2) {
      var urn = _ref2.urn;
      return urn === (currentUserClassifier === null || currentUserClassifier === void 0 ? void 0 : currentUserClassifier.projectUrn);
    }) || null;
  }, [currentUserClassifier === null || currentUserClassifier === void 0 ? void 0 : currentUserClassifier.projectUrn, projectList]);
  useEffect(function () {
    importEstimationService.setSelectedProject(currentProject);
  }, [currentProject]);
  return /*#__PURE__*/_jsx(SwitchProject, {
    noMaxWith: true,
    projectList: projectList,
    disabled: fetchProjectListPending,
    loading: fetchProjectListPending,
    size: "medium",
    onChangeProject: function onChangeProject(project) {
      importEstimationService.setSelectedProject(project);
    },
    selectedProjectName: (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.name) || '',
    onToggle: function onToggle() {
      return setOpenedSwitchProjectPopup(function (prev) {
        return !prev;
      });
    },
    opened: openedSwitchProjectPopup,
    onClose: function onClose() {
      return setOpenedSwitchProjectPopup(false);
    },
    renderBadgeContent: function renderBadgeContent(params) {
      return /*#__PURE__*/_jsxs(BadgeLabel, {
        children: [/*#__PURE__*/_jsx(AllFolders, {}), " ", params.projectName, /*#__PURE__*/_jsx(ProjectSourceBubble, {
          children: (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.sourceType) === 'Bim360' ? 'BIM 360' : 'G-tec'
        })]
      });
    }
  });
};